module.exports = __webpack_public_path__ + "media/packs/images/flags/CK-79f990ace18f35453399d156a4d5fef7.svg";